import { useTheme } from './context/ThemeContext';
import PageHeader from './components/PageHeader';
import Footer from './components/Footer';
import matrixLogo from './images/cybersmithio.png';
import blueLogo from './images/cybersmithio-blue-logo.jpg';
import lightLogo from './images/cybersmithio-whitebg-logo.jpg';
import './App.css';

function App() {
  const { theme } = useTheme();
  const getLogo = () => {
    if (theme === 'matrix') return matrixLogo;
    if (theme === 'light') return lightLogo;
    return blueLogo;
  };
  const logo = getLogo();

  return (
    <div className="App">
      <PageHeader />
      <header className="App-header">
        <h2 className="App-tagline">Forging Digital Security Solutions</h2>
        <img src={logo} className="App-logo" alt="cybersmith.io logo" />
      </header>
      <Footer />
    </div>
  );
}

export default App;
